var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"buttons":['cancel'],"title":"FAA"}},[_c('rkm-alert',{staticClass:"mb-3"},[_c('span',[_c('strong',[_vm._v("Paciente:")]),_vm._v(" "+_vm._s(_vm.nomePaciente)+" ")])]),_c('List',{attrs:{"faas":_vm.faas},on:{"select":_vm.handleSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }